import { gql } from "@apollo/client";

export const GET_JUSTIFICACIONES_ESTADOS = gql`
  query GetJusticacionesEstados {
    justicacionesEstados {
      idEstado
      descripcion
      codigo
    }
  }
`;